import { render, staticRenderFns } from "./SelectVideoModal.vue?vue&type=template&id=60c1c431&scoped=true"
import script from "./SelectVideoModal.vue?vue&type=script&lang=ts"
export * from "./SelectVideoModal.vue?vue&type=script&lang=ts"
import style0 from "./SelectVideoModal.vue?vue&type=style&index=0&id=60c1c431&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c1c431",
  null
  
)

export default component.exports